import {createStyles, Stack, Box, Typography} from "@mui/material";
import AssetsTransItem from "./AssetsTransItem.tsx";
import {useEffect} from "react";
import dayjs from "dayjs";
import classes from "./index.module.less";

interface Props {
  dateText: string;
  list: any[],
  onClick: (item: any) => void;
}

const DayAssetsTransItem = (props: Props) => {

  const {dateText, list, onClick} = props;

  return (<>
    <Box className={classes["flow-container"]}>
      <Box>
        <p className={classes["flow-date"]}>{dayjs(dateText).format('dddd, MMMM d')}</p>
      </Box>
      {
        list.map((item) => (
          <Box key={dateText} onClick={() => {onClick && onClick(item)}}>
            <AssetsTransItem record={item} key={dateText}/>
          </Box>
        ))
      }
    </Box>
  </>)
}

export default DayAssetsTransItem